module.exports = __webpack_public_path__ + "static/img/video-cover-1.62e8e51f.png";